import { createFileRoute } from '@tanstack/react-router';

import { EditDriverForm } from '@/areas/manufacturing-templates/Drivers/DriverCreation/EditDriverForm';
import { canEditManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/drivers/$driverId/edit')({
    staticData: { access: { permissions: canEditManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <PageLayout layout="full-width">
            <EditDriverForm driverId={pathParams.driverId} />
        </PageLayout>
    );
}
